const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Post patrocinado en TNO Digest / redes',
    annualPrice: 'Por publicación: 100',
    monthlyPrice: 100,
    features: [
      'Publicación patrocinada en redes sociales de Pedro con las Mascotas y TNO Network',
      'Alcance en el ecosistema digital del programa',
      'Contenido adaptado a bienestar animal y pet lovers',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en redes sin compromiso de programa en vivo.',
    duration: 'Por publicación',
    buttonText: 'Solicitar post',
    highlightedTitle: 'Visibilidad en redes',
    highlightedContent: [
      'Tu marca en el feed oficial de Pedro con las Mascotas y TNO Digest.',
      'Ideal para lanzamientos, promociones o reforzar una campaña.',
    ],
    highlightedButtonText: 'Solicitar post',
  },
  {
    title: 'Sección del programa presentada por tu marca',
    annualPrice: 'Trimestral: 240',
    monthlyPrice: 80,
    features: [
      'Mención exclusiva: "Esta sección presentada por [tu marca]"',
      'Vinculación a una sección fija: El Consultorio, Conducta Animal, Mascotas de Estrellas, Moda y Tendencia o Expedición Animal',
      'Presencia en el bloque correspondiente de cada emisión',
      'Contenido alineado con el ADN de tu marca',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan asociarse a una sección concreta del programa sin compromiso de contenido editorial.',
    duration: 'Suscripción Mensual',
    buttonText: 'Elegir mi sección',
    highlightedTitle: 'Tu marca en una sección',
    highlightedContent: [
      'Tu marca acompaña cada emisión de la sección elegida.',
      'Ideal para clínicas, alimentos, accesorios o servicios pet con mensaje claro.',
    ],
    highlightedButtonText: 'Consultar secciones',
  },
  {
    title: 'Segmento o contenido editorial',
    annualPrice: 'Trimestral: 360',
    monthlyPrice: 120,
    features: [
      'Segmento dedicado con especialistas (veterinarios, etólogos, entrenadores)',
      'Artículo o crónica en TNO Digest sobre bienestar animal',
      'Vinculación con una temática: nutrición, salud, conducta o estilo de vida pet',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan relevancia temática y afinidad con el contenido de cuidado animal.',
    duration: 'Suscripción Mensual',
    buttonText: 'Consultar opciones',
    highlightedTitle: 'Autoridad de nicho',
    highlightedContent: [
      'Tu marca se convierte en referente del segmento elegido.',
      'Asociación orgánica con bienestar animal y estilo de vida pet-friendly.',
      'Ideal para posicionar productos en contextos de alta afinidad.',
    ],
    highlightedButtonText: 'Contactar a ventas',
  },
  {
    title: 'Pedro con las Mascotas – Aliado del bienestar animal',
    annualPrice: 'Trimestral: 720',
    monthlyPrice: 240,
    features: [
      'Menciones en estudio durante la transmisión en vivo',
      'Segmentos con especialistas (veterinarios, etólogos) vinculados a tu marca',
      'Contenido editorial en TNO Digest sobre cuidados y bienestar animal',
      'Tu marca posicionada como aliado natural del bienestar en el hogar',
      'Presencia en web, app y redes sociales del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de alimento para mascotas, clínicas veterinarias, accesorios pet-friendly, seguros y productos de cuidado animal que buscan conectar con una audiencia emocionalmente comprometida.',
    duration: 'Mensual',
    buttonText: 'Ser parte de la familia',
    highlightedTitle: 'Contenido con Corazón',
    highlightedContent: [
      'Tu marca en el espacio de referencia para pet lovers en TNO Network.',
      'Menciones en estudio, segmentos de especialistas y contenido editorial: tu marca como aliado del bienestar animal.',
      'Pedro con las Mascotas, con Pedro Scutaro. Ellos también tienen una historia que contar.',
    ],
    highlightedButtonText: 'Contactar a ventas',
  },
  {
    title: 'Paquete premium – Sponsorship exclusivo',
    annualPrice: 'Trimestral: 1440',
    monthlyPrice: 480,
    features: [
      'Sponsorship principal del programa con menciones de apertura y cierre',
      'Tres menciones en vivo + video comercial de 20 segundos durante la transmisión',
      'Segmentos con especialistas vinculados a tu marca',
      'Contenido editorial en TNO Digest y presencia en web, app y redes',
      'Exclusividad de rubro (solo una marca por categoría en el programa)',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas líderes en alimento, clínicas veterinarias o seguros que buscan posicionamiento exclusivo ante la audiencia pet.',
    duration: 'Mensual',
    buttonText: 'Ser patrocinante principal',
    highlightedTitle: 'Máxima visibilidad',
    highlightedContent: [
      'Tu marca como aliado exclusivo de Pedro con las Mascotas.',
      'Máximo impacto: menciones, comercial, segmentos y contenido editorial.',
      'Ideal para estrategias de largo plazo en el nicho pet.',
    ],
    highlightedButtonText: 'Contactar a ventas',
  },
];

export default optionsData;
